var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { api } from './baseApi';
export var referralApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            // 1. Получить статистику по ВСЕМ реферальным кодам (с пагинацией)
            getAllReferralStats: builder.query({
                query: function (_a) {
                    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 20 : _c;
                    return ({
                        url: "/users/referral/stats/all",
                        params: { page: page, limit: limit },
                    });
                },
                providesTags: ['ReferralStats'],
            }),
            // 2. Получить пользователей по конкретному реферальному коду (без пагинации)
            getUsersByReferralCode: builder.query({
                query: function (_a) {
                    var referralCode = _a.referralCode;
                    return ({
                        url: "/users/referral/code/".concat(referralCode, "/users"),
                    });
                },
                providesTags: function (result, error, _a) {
                    var referralCode = _a.referralCode;
                    return [
                        { type: 'ReferralUsers', id: referralCode }
                    ];
                },
            }),
            // 2.1. Получить пользователей по конкретному реферальному коду (С ПАГИНАЦИЕЙ)
            getUsersByReferralCodeWithPagination: builder.query({
                query: function (_a) {
                    var referralCode = _a.referralCode, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 20 : _c;
                    return ({
                        url: "/users/referral/code/".concat(referralCode, "/users"),
                        params: { page: page, limit: limit },
                    });
                },
                providesTags: function (result, error, _a) {
                    var referralCode = _a.referralCode;
                    return [
                        { type: 'ReferralUsers', id: "".concat(referralCode, "-pagination") }
                    ];
                },
            }),
            // 3. Получить общую статистику реферальной системы
            getReferralSystemStats: builder.query({
                query: function () {
                    return ({
                        url: "/users/referral/system-stats",
                    });
                },
                providesTags: ['ReferralSystemStats'],
            }),
            // 4. Получить информацию о моем реферальном коде
            getMyReferralInfo: builder.query({
                query: function () {
                    return ({
                        url: "/users/referral/my",
                    });
                },
                providesTags: ['MyReferral'],
            }),
            // 5. Получить реферальную информацию по ID пользователя
            getUserReferralInfo: builder.query({
                query: function (_a) {
                    var userId = _a.userId;
                    return ({
                        url: "/users/referral/user/".concat(userId),
                    });
                },
                providesTags: function (result, error, _a) {
                    var userId = _a.userId;
                    return [
                        { type: 'UserReferral', id: userId }
                    ];
                },
            }),
            // 6. Применить реферальный код (для существующих пользователей)
            applyReferralCode: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/users/referral/apply",
                        body: body,
                    });
                },
                invalidatesTags: ['MyReferral', 'ReferralStats', 'ReferralSystemStats'],
            }),
            // 7. Получить топ приглашающих
            getTopReferrers: builder.query({
                query: function (_a) {
                    var _b = _a.limit, limit = _b === void 0 ? 10 : _b;
                    return ({
                        url: "/users/referral/top",
                        params: { limit: limit },
                    });
                },
                providesTags: ['TopReferrers'],
            }),
            // 8. Экспорт реферальных данных
            exportReferralData: builder.query({
                query: function () {
                    return ({
                        url: "/users/referral/export",
                    });
                },
            }),
            // 9. Проверить валидность реферального кода
            validateReferralCode: builder.query({
                query: function (_a) {
                    var referralCode = _a.referralCode;
                    return ({
                        url: "/users/referral/validate/".concat(referralCode),
                    });
                },
            }),
            // 10. Получить реферальную статистику за период (для админки)
            getReferralStatsByPeriod: builder.query({
                query: function (_a) {
                    var period = _a.period;
                    return ({
                        url: "/users/referral/stats/period",
                        params: { period: period },
                    });
                },
                providesTags: ['ReferralPeriodStats'],
            }),
            // 11. Получить все реферальные коды с пагинацией и поиском
            getAllReferralCodes: builder.query({
                query: function (_a) {
                    var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.limit, limit = _c === void 0 ? 20 : _c, search = _a.search;
                    return ({
                        url: "/users/referral/codes/all",
                        params: __assign({ page: page, limit: limit }, (search && { search: search })),
                    });
                },
                providesTags: ['ReferralCodes'],
            }),
            // 12. Поиск реферальных кодов (автокомплит)
            searchReferralCodes: builder.query({
                query: function (_a) {
                    var search = _a.search;
                    return ({
                        url: "/users/referral/codes",
                        params: __assign({}, (search && { search: search })),
                    });
                },
                providesTags: ['ReferralCodes'],
            }),
            // 13. Получить информацию о конкретном реферальном коде
            getReferralCodeInfo: builder.query({
                query: function (_a) {
                    var referralCode = _a.referralCode;
                    return ({
                        url: "/users/referral/code/".concat(referralCode, "/info"),
                    });
                },
                providesTags: function (result, error, _a) {
                    var referralCode = _a.referralCode;
                    return [
                        { type: 'ReferralCode', id: referralCode }
                    ];
                },
            }),
        });
    },
});
// Экспортируем хуки для использования в компонентах
export var 
// Основные хуки
useGetAllReferralStatsQuery = referralApi.useGetAllReferralStatsQuery, useLazyGetAllReferralStatsQuery = referralApi.useLazyGetAllReferralStatsQuery, useGetUsersByReferralCodeQuery = referralApi.useGetUsersByReferralCodeQuery, useLazyGetUsersByReferralCodeQuery = referralApi.useLazyGetUsersByReferralCodeQuery, 
// Новый хук с пагинацией
useGetUsersByReferralCodeWithPaginationQuery = referralApi.useGetUsersByReferralCodeWithPaginationQuery, useLazyGetUsersByReferralCodeWithPaginationQuery = referralApi.useLazyGetUsersByReferralCodeWithPaginationQuery, useGetReferralSystemStatsQuery = referralApi.useGetReferralSystemStatsQuery, useLazyGetReferralSystemStatsQuery = referralApi.useLazyGetReferralSystemStatsQuery, useGetMyReferralInfoQuery = referralApi.useGetMyReferralInfoQuery, useLazyGetMyReferralInfoQuery = referralApi.useLazyGetMyReferralInfoQuery, useGetUserReferralInfoQuery = referralApi.useGetUserReferralInfoQuery, useLazyGetUserReferralInfoQuery = referralApi.useLazyGetUserReferralInfoQuery, useApplyReferralCodeMutation = referralApi.useApplyReferralCodeMutation, useGetTopReferrersQuery = referralApi.useGetTopReferrersQuery, useLazyGetTopReferrersQuery = referralApi.useLazyGetTopReferrersQuery, useExportReferralDataQuery = referralApi.useExportReferralDataQuery, useLazyExportReferralDataQuery = referralApi.useLazyExportReferralDataQuery, useValidateReferralCodeQuery = referralApi.useValidateReferralCodeQuery, useLazyValidateReferralCodeQuery = referralApi.useLazyValidateReferralCodeQuery, useGetReferralStatsByPeriodQuery = referralApi.useGetReferralStatsByPeriodQuery, useLazyGetReferralStatsByPeriodQuery = referralApi.useLazyGetReferralStatsByPeriodQuery, 
// НОВЫЕ ХУКИ
useGetAllReferralCodesQuery = referralApi.useGetAllReferralCodesQuery, useLazyGetAllReferralCodesQuery = referralApi.useLazyGetAllReferralCodesQuery, useSearchReferralCodesQuery = referralApi.useSearchReferralCodesQuery, useLazySearchReferralCodesQuery = referralApi.useLazySearchReferralCodesQuery, useGetReferralCodeInfoQuery = referralApi.useGetReferralCodeInfoQuery, useLazyGetReferralCodeInfoQuery = referralApi.useLazyGetReferralCodeInfoQuery;
// Добавляем теги в общий список (нужно добавить в baseApi.ts)
// tags: [
//   'ReferralStats',
//   'ReferralSystemStats',
//   'MyReferral',
//   'UserReferral',
//   'TopReferrers',
//   'ReferralPeriodStats',
//   'ReferralUsers',
//   'ReferralCodes',
//   'ReferralCode'
// ]
